import React from 'react';
import clsx from 'clsx';

import './form.scss';

const Form = (props) => {
  const { children, className, ...rest } = props;
  const classes = clsx('form', className);

  return (
    <form
      className={classes}
      {...rest}
    >
      {children}
    </form>
  );
};

export default Form;
